import translationsSecureData from '../../../channels/secure-web/assets/static/dictionary-en-GB.json';
import translationsPublicData from '../../../channels/public-web/assets/static/dictionary-en-GB.json';
import testsDiscoveryServiceData from './mocks/discovery.service.tests.json';
import localDiscoveryServiceData from './mocks/discovery.service.local.json';
import availableLanguagesData from './mocks/dashboard/available.languages.json';
import notificationsData from './mocks/dashboard/notifications.TODO.json';
import pendingAuthorizationsData from './mocks/dashboard/pending.authorizations.TODO.json';
import persistSelectedLanguageData from './mocks/dashboard/persist.selected.language.TODO.json';
import accountDetailsData from './mocks/dashboard/private.accounts.92056.deposits.102.json';
import accountsListData from './mocks/dashboard/private.accounts.92056.deposits.json';
import dashboardData from './mocks/dashboard/private.accounts.dashboard.json';
import transactionsListData from './mocks/dashboard/private.transactions.account.0001000000008.json';
import transactionStatusesData from './mocks/dashboard/private.transactions.parameters.statuses.json';
import transactionTypesData from './mocks/dashboard/private.transactions.parameters.types.json';
import beneficiariesData from './mocks/user/private.users.beneficiaries.3009900000001.json';
import beneficiaryData from './mocks/user/private.users.beneficiaries.3009900000001.345.json';
import postBeneficiaryData from './mocks/user/private.users.beneficiaries.post.json';
import editBeneficiaryData from './mocks/user/private.users.beneficiaries.edit.json';
import postLoginData from './mocks/dashboard/private.users.postLogin.json';
import tokenData from './mocks/dashboard/token.json';
import devicesData from './mocks/device/private.devices.json';
import deleteDeviceAuthorizationData from './mocks/device/private.devices.deletion.authorization.json';
import registerNewDeviceData from './mocks/device/private.devices.new.json';
import favoriteTransactionsListData from './mocks/user/private.users.transactions.favorites.json';
import favoriteTransactionPostData from './mocks/user/private.users.transactions.favorites.post.json';
import editFavoriteTransactionData from './mocks/user/private.users.transactions.favorites.3009900000001.json';
import authorizationsOTPData from './mocks/device/private.devices.authorizations.otp.json';
import otpPhoneAuthorizationData from './mocks/user/private.users.phone.authorization.json';
import phoneUsersData from './mocks/user/private.users.phone.json';
import fallbackOTPData from './mocks/device/private.devices.authorizations.fallback.json';
import resendAuthorizationData from './mocks/device/private.devices.authorizations.resend.json';
import changePasswordAuthorizationData from './mocks/user/private.users.password.authorization.json';
import changeUsernameAuthorizationData from './mocks/user/private.user.username.authorization.json';
import changePasswordData from './mocks/user/private.users.password.json';
import changeUsernameData from './mocks/user/private.users.username.json';
import passwordPolicyData from './mocks/user/private.users.password.policy.json';
import usernameRulesData from './mocks/user/private.users.username.rules.json';
import upsertAliasData from './mocks/account/private.accounts.alias.upsert.json';
import deleteAliasData from './mocks/account/private.accounts.alias.delete.json';
import standingOrdersData from './mocks/order/private.orders.standing.json';
import sweepOrdersData from './mocks/order/private.orders.sweep.json';
import standingOrdersDetailsData from './mocks/order/private.orders.standing.details.json';
import sweepOrdersDetailsData from './mocks/order/private.orders.sweep.details.json';
import consolidatedTransactionsData from './mocks/dashboard/private.transactions.fund-transfers.consolidated-history.json';
import orderStatusesData from './mocks/dashboard/private.transfers.parameters.order-statuses.json';
import onboardingProspectData from './mocks/onboarding/public.accounts.prospect.json';
import verifyEmailData from './mocks/user/public.users.verifyEmail.authorizations.json';
import currenciesData from './mocks/transfers/private.transfers.parameters.currencies.json';
import exchangeCalculateData from './mocks/transfers/private.transfers.exchange.calculate.json';
import countriesData from './mocks/transfers/public.accounts.parameters.countries.json';
import chargingMethodsData from './mocks/transfers/private.accounts.parameters.chargingMethods.json';
import initiateTransferData from './mocks/transfers/private.transfers.initiate.json';
import makeTransferData from './mocks/transfers/private.transfers.make.json';
import cardData from './mocks/cards/private.cards.92056.json';
import cardStatusesData from './mocks/cards/private.cards.paremeters.statuses.json';
import cardTransactionsData from './mocks/cards/private.cards.92056.transactions.1.json';
import cardTransactionDetailsData from './mocks/cards/private.cards.92056.transaction.1.json';
import initTopUpAuthorizationData from './mocks/cards/private.cards.initTopUp.json';
import postTopUpData from './mocks/cards/private.cards.post.top.up.json';
import cardFreeze from './mocks/cards/private.cards.92056.freeze.1.json';
import cardAuthorizationData from './mocks/cards/private.cards.authorization.json';
import onBoardingProfessionsListData from './mocks/onboarding/public.accounts.parameters.professions.json';
import onBoardingIdTypesListData from './mocks/onboarding/public.accounts.parameters.idtypes.json';
import onBoardingCountriesListData from './mocks/onboarding/public.accounts.parameters.countries.json';
import mandateTransferData from './mocks/transfers/private.transfers.mandates.json';
import mandateExecutionData from './mocks/transfers/private.transfers.mandates.execute.json';
import mandateCheckData from './mocks/transfers/private.transfers.mandates.check.json';
import consentData from './mocks/user/private.users.consent.json';
import consolidatedTransactionDetailsData from './mocks/dashboard/private.transactions.fundtransfers.single.json';
import transactionDocumentsData from './mocks/dashboard/private.transactions.document.92056.15.json';
import transactionSingleDocumentData from './mocks/dashboard/private.transactions.document.92056.data.json';
import fundTransferRoutingData from './mocks/transfers/private.transfers.routing.json';
import fundTransferForecastData from './mocks/transfers/private.transfers.forecast.json';
import fundTransferVopData from './mocks/transfers/private.transfers.vop.json';
import fundTransfersPostDocumentData from './mocks/transfers/private.transfers.post.document.json';
import fundTransfersPutDocumentData from './mocks/transfers/private.transfers.put.document.json';
import cardDetailsData from './mocks/cards/private.cards.92056.details.json';
import fundTransfersDeleteDocumentData from './mocks/transfers/private.transfers.delete.document.json';
import appTransactionsData from './mocks/dashboard/private.users.appTransactions.json';
import webAuthorizationStatusData from './mocks/device/private.devices.web.authorizations.status.json';
import professionsData from './mocks/accounts/public.accounts.parameters.professions.json';
import idTypesData from './mocks/accounts/public.accounts.parameters.idTypes.json';
import favoriteTransferData from './mocks/transfers/private.transfers.favorite.3009900000001.1234.json';
import favoriteTransferListData from './mocks/transfers/private.transfers.favorites.3009900000001.json';
import favoriteAppTransactionPostData from './mocks/transfers/private.transfers.favorites.appTransaction.post.json';
import favoriteTransferPostData from './mocks/transfers/private.transfers.favorite.post.json';
import favoriteTransferEditData from './mocks/transfers/private.transfers.favorite.edit.3009900000001.1234.json';
import favoriteTransferDeleteData from './mocks/transfers/private.transfers.favorite.delete.3009900000001.1234.json';
import activityLogListData from './mocks/activityLog/private.activityLogList.3009900000001.json';
import activityLogDetailsData from './mocks/activityLog/private.activityLogDetails.391.json';
import fundTransfersBankSwiftCodesData from './mocks/transfers/private.transfers.bank.swift.codes.json';
import fundTransfersSwiftCitiesData from './mocks/transfers/private.transfers.swift.cities.json';
import fundTransfersSwiftBanksData from './mocks/transfers/private.transfers.swift.banks.json';
import fundTransfersBopCodesData from './mocks/transfers/private.transfers.parameters.bopcodes.json';
import fundTransfersVocCodesData from './mocks/transfers/private.transfers.parameters.voccodes.json';
import fundTransfersExecuteDealerRateData from './mocks/transfers/private.transfers.dealer_rate.execute.json';
import fundTransfersDealerRatesData from './mocks/transfers/private.transfers.exchange.dealer-rates.json';
import payrollListData from './mocks/payroll/private.bulk.payroll.list.92056.json';
import payrollFileTypes from './mocks/payroll/private.bulk.payroll.fileTypes.json';
import payrollProcessAuthorizationData from './mocks/payroll/private.bulk.payroll.file.process.92056.1234.json';
import payrollUploadFileData from './mocks/payroll/private.bulk.payroll.92056.file.json';
import payrollCreateProcessingAuthorizationData from './mocks/payroll/private.bulk.payroll.file.92056.12.initiate.json';
import payrollTotalData from './mocks/payroll/private.bulk.payroll.47389.total.json';
import payrollDetailsData from './mocks/payroll/private.bulk.payroll.details.92056.12.json';
import payrollDeleteData from './mocks/payroll/private.bulk.payroll.47389.json';
import issueCardStartData from './mocks/cards/issue/issue.start.json';
import issueCardAccountSelectorData from './mocks/cards/issue/issue.PRODUCT_SELECTOR.NEXT.json';
import issueCardAuthorizationData from './mocks/cards/issue/issue.VERIFY.NEXT.json';
import issueCardVerifyData from './mocks/cards/issue/issue.ACCOUNT_SELECTOR.NEXT.json';
import issueCardEndData from './mocks/cards/issue/issue.AUTHORIZATION.NEXT.json';
import issueCardRequestEndData from './mocks/cards/issue/issue.start.NEXT.json';
import topupCardExternalPaymentData from './mocks/cards/topup/topup.start.json';
import topupCardStartData from './mocks/cards/topup/topup.FROM_ACCOUNT_AND_AMOUNT.NEXT.json';
import topupCardVerifyData from './mocks/cards/topup/topup.PAYMENT_CARD_EXTERNAL.NEXT.json';
import topupCardAuthorizationData from './mocks/cards/topup/topup.VERIFY.NEXT.json';
import topupCardEndData from './mocks/cards/topup/topup.AUTHORIZATION.NEXT.json';
import topupCardGenericErrorData from './mocks/cards/topup/topup.GENERIC_ERROR.json';
import terminateCardStartData from './mocks/cards/terminate/terminate.start.json';
import terminateCardVerifyData from './mocks/cards/terminate/terminate.ACCOUNT_SELECTOR.NEXT.json';
import terminateCardAuthorizationData from './mocks/cards/terminate/terminate.VERIFY.NEXT.json';
import terminateCardResultData from './mocks/cards/terminate/terminate.AUTHORIZATION.NEXT.json';
import replaceCardStartData from './mocks/cards/replace/replace.start.json';
import replaceCardAccountSelectorData from './mocks/cards/replace/replace.CARD_TERMINATE_REASON.NEXT.json';
import replaceCardVerifyData from './mocks/cards/replace/replace.ACCOUNT_SELECTOR.NEXT.json';
import replaceCardAuthorizationData from './mocks/cards/replace/replace.VERIFY.NEXT.json';
import replaceCardResultData from './mocks/cards/replace/replace.AUTHORIZATION.NEXT.json';
import permanentBlockCardStartData from './mocks/cards/permanentBlock/permanentBlock.start.json';
import permanentBlockCardVerifyData from './mocks/cards/permanentBlock/permanentBlock.CARD_TERMINATE_REASON.NEXT.json';
import permanentBlockCardAuthorizationData from './mocks/cards/permanentBlock/permanentBlock.VERIFY.NEXT.json';
import permanentBlockCardResultData from './mocks/cards/permanentBlock/permanentBlock.AUTHORIZATION.NEXT.json';
import cardHeadersResponse from './mocks/cards/private.cards.headers.json';
import activeCurrenciesData from './mocks/iban/private.accounts.currencies.active.json';
import productsData from './mocks/iban/private.accounts.products.json';
import requestIbanAccount from './mocks/iban/private.accounts.request.iban.json';
import transactionDetailsPrintData from './mocks/dashboard/private.transactions.fundtransfers.single.PDF.json';
import accountIbanCertificateData from './mocks/iban/private.accounts.certificate.12334566.json';
import transactionsPrintPDFData from './mocks/dashboard/private.transactions.fund-transfers.consolidated-history.print.PDF.json';
import transactionsPrintXLSXData from './mocks/dashboard/private.transactions.fund-transfers.consolidated-history.print.XLSX.json';
import mandateInitiateData from './mocks/transfers/private.transfers.mandates.initiate.json';
import transactionDocumentUploadData from './mocks/dashboard/private.transactions.document.92056.json';
import bicSwiftCodeData from './mocks/transfers/private.transfers.bank.bic.swift.code.json';
import communicationAlertsData from './mocks/user/private.user.communication.92056.json';
import cardTransactionsExportData from './mocks/cards/private.cards.prepaid.export.json';
import fundTransfersDateTransfer from './mocks/transfers/private.transfers.date.json';
import fundTransfersSwiftCountriesData from './mocks/transfers/private.transfers.bank.swift.countries.json';
import issueCorporateCardStartData from './mocks/cards/issue/issue.corporate.start.json';
import issueCorporateCardProductSelectorData from './mocks/cards/issue/issue.corporate.PARTY_SELECTOR.NEXT.json';
import issueCorporateCardAccountSelectorData from './mocks/cards/issue/issue.corporate.PRODUCT_SELECTOR.NEXT.json';
import issueCorporateCardVerifyData from './mocks/cards/issue/issue.corporate.ACCOUNT_SELECTOR.NEXT.json';
import issueCorporateCardAuthorizationData from './mocks/cards/issue/issue.corporate.VERIFY.NEXT.json';
import issueCorporateCardEndData from './mocks/cards/issue/issue.corporate.AUTHORIZATION.NEXT.json';
import searchCurrencyData from './mocks/transfers/private.accounts.currencies.search.json';
import orderChargesData from './mocks/transfers/private.transfers.1.charges.json';

const ecommbx = {
  testsDiscoveryServiceData,
  localDiscoveryServiceData,
  availableLanguagesData,
  notificationsData,
  pendingAuthorizationsData,
  persistSelectedLanguageData,
  accountDetailsData,
  accountsListData,
  dashboardData,
  transactionsListData,
  transactionStatusesData,
  transactionTypesData,
  postLoginData,
  tokenData,
  translationsPublicData,
  translationsSecureData,
  devicesData,
  deleteDeviceAuthorizationData,
  registerNewDeviceData,
  favoriteTransactionsListData,
  favoriteTransactionPostData,
  editFavoriteTransactionData,
  authorizationsOTPData,
  otpPhoneAuthorizationData,
  phoneUsersData,
  fallbackOTPData,
  resendAuthorizationData,
  changePasswordAuthorizationData,
  changeUsernameAuthorizationData,
  changePasswordData,
  changeUsernameData,
  passwordPolicyData,
  usernameRulesData,
  beneficiariesData,
  beneficiaryData,
  editBeneficiaryData,
  postBeneficiaryData,
  upsertAliasData,
  deleteAliasData,
  standingOrdersData,
  sweepOrdersData,
  standingOrdersDetailsData,
  sweepOrdersDetailsData,
  consolidatedTransactionsData,
  onboardingProspectData,
  verifyEmailData,
  currenciesData,
  exchangeCalculateData,
  countriesData,
  chargingMethodsData,
  initiateTransferData,
  makeTransferData,
  orderStatuses: orderStatusesData,
  deleteBeneficiaryData: editBeneficiaryData,
  cardData,
  cardStatusesData,
  cardTransactionsData,
  cardTransactionDetailsData,
  initTopUpAuthorizationData,
  postTopUpData,
  cardFreeze,
  cardAuthorizationData,
  onBoardingProfessionsListData,
  onBoardingIdTypesListData,
  onBoardingCountriesListData,
  mandateTransferData,
  mandateExecutionData,
  mandateCheckData,
  consentData,
  consolidatedTransactionDetailsData,
  transactionDocumentsData,
  transactionSingleDocumentData,
  fundTransferRoutingData,
  fundTransferForecastData,
  fundTransferVopData,
  fundTransfersPostDocumentData,
  fundTransfersPutDocumentData,
  cardDetailsData,
  fundTransfersDeleteDocumentData,
  appTransactionsData,
  webAuthorizationStatusData,
  professionsData,
  idTypesData,
  favoriteTransferData,
  favoriteTransferListData,
  favoriteAppTransactionPostData,
  favoriteTransferPostData,
  favoriteTransferEditData,
  favoriteTransferDeleteData,
  activityLogListData,
  activityLogDetailsData,
  fundTransfersBankSwiftCodesData,
  fundTransfersSwiftCitiesData,
  fundTransfersSwiftBanksData,
  fundTransfersBopCodesData,
  fundTransfersVocCodesData,
  fundTransfersExecuteDealerRateData,
  fundTransfersDealerRatesData,
  payrollListData,
  payrollFileTypes,
  payrollProcessAuthorizationData,
  payrollUploadFileData,
  payrollCreateProcessingAuthorizationData,
  payrollTotalData,
  payrollDetailsData,
  payrollDeleteData,
  cardHeadersResponse,
  issueCardStartData,
  issueCardAccountSelectorData,
  issueCardVerifyData,
  issueCardAuthorizationData,
  issueCardEndData,
  topupCardStartData,
  topupCardExternalPaymentData,
  topupCardVerifyData,
  topupCardAuthorizationData,
  topupCardGenericErrorData,
  topupCardEndData,
  terminateCardStartData,
  terminateCardVerifyData,
  terminateCardAuthorizationData,
  terminateCardResultData,
  replaceCardStartData,
  replaceCardAccountSelectorData,
  replaceCardVerifyData,
  replaceCardAuthorizationData,
  replaceCardResultData,
  activeCurrenciesData,
  productsData,
  requestIbanAccount,
  transactionDetailsPrintData,
  accountIbanCertificateData,
  transactionsPrintPDFData,
  transactionsPrintXLSXData,
  mandateInitiateData,
  transactionDocumentUploadData,
  bicSwiftCodeData,
  communicationAlertsData,
  cardTransactionsExportData,
  fundTransfersDateTransfer,
  fundTransfersSwiftCountriesData,
  issueCorporateCardStartData,
  issueCorporateCardProductSelectorData,
  issueCorporateCardAccountSelectorData,
  issueCorporateCardVerifyData,
  issueCorporateCardAuthorizationData,
  issueCorporateCardEndData,
  searchCurrencyData,
  orderChargesData,
  issueCardRequestEndData,
  permanentBlockCardAuthorizationData,
  permanentBlockCardResultData,
  permanentBlockCardStartData,
  permanentBlockCardVerifyData,
};

export { ecommbx };
